/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type { Payload as ForcPayload } from "parog-web/components/forc/abstract/journal-event-based-component";
import BaseMedicalHistoryFormComponent from "parog-web/components/medical-history/abstract/base-edition-form";
import MedicalHistoryBaseEditionForm from "../base-edition-form";

export default class MedicalHistoryFormComponent extends BaseMedicalHistoryFormComponent {
  MedicalHistoryBaseEditionForm = MedicalHistoryBaseEditionForm;

  journalEventProperties = [
    ...this.sharedProperties,
    ...this.pathologyProperties
  ];

  get pathologyProperties(): string[] {
    return ["diagnosticType", "diseaseActivity", "diagnosisDate"];
  }

  computePayload(): ForcPayload {
    const payload = super.computePayload();

    if (!this.args.patient.isRch) {
      delete payload.diagnosticType;
    }

    return payload;
  }
}
